import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {OrganizationRights} from "../api";

export class UserRightsService extends RestService<OrganizationRights> {
    constructor(url: string) {
        if (url) {
            var lastChar = url.substr(-1) // Selects the last character
            if (lastChar !== '/') {
                // If the last character is not a slash
                url = url + '/' // Append a slash to it.
            }
        }
        url ? super(url) : super(REST_API_END_POINTS.RIGHTS)
    }
}
